import { QuoteBodyAccordion } from '../../../../components/Quotes/QuoteBodyAccordion';
import { QuoteCustomFields } from '../../Quote/components/QuoteCustomFields';
import { useQuoteContext } from '../../Quote/quoteContext';

export const QuoteInternalCustomFields = ({ value }: { value?: string }) => {
  const { quoteData } = useQuoteContext();
  const { quote } = quoteData;

  if (!quote) {
    return null;
  }

  return (
    <QuoteBodyAccordion value={value} title="Additional Fields">
      <QuoteCustomFields showDivider={false} mode="page" />
    </QuoteBodyAccordion>
  );
};
